




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import {State} from "vuex-class";

@Component({})
export default class VrsteOdrzavanjaEditor extends Vue {
    @State vrsteOdrzavanja!: [];
    @Prop() value!: string;

    model = '';

    @Watch('value') onValueChange(value) {
        this.model = value;
    }

    @Watch('model') onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {}

    async created() {
        this.model = this.value;
    }
}

